import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Page from './containers/page'

import { hasVisaPlusTreatment } from '../../js/experiments/visa-plus'

import {
  Onboard,
  Profile,
  NextSteps,
  ConfirmPhone,
  SendToApp,
} from './lazy-components'

export default () => {
  // NOTE: Need to do some checks with routing for redirects based on eligibility
  // https://github.paypal.com/briwong/ppmenodeweb/blob/develop/client/src/screens/seller/with-experience-check.js
  // https://github.paypal.com/ConsumerWeb-R/ppmenodeweb/pull/2220/files

  const test = hasVisaPlusTreatment()

  return test ? (
    <Route path="/myaccount/transfer/visa-plus">
      <Page>
        <Switch>
          <Route
            exact
            path="/myaccount/transfer/visa-plus/onboard"
            render={props => <Onboard {...props} />}
          />
          <Route
            exact
            path="/myaccount/transfer/visa-plus/profile"
            render={props => <Profile {...props} />}
          />
          <Route
            exact
            path="/myaccount/transfer/visa-plus/nextsteps"
            render={props => <NextSteps {...props} />}
          />
          <Route
            exact
            path="/myaccount/transfer/visa-plus/confirmphone"
            render={props => <ConfirmPhone {...props} />}
          />
          <Route
            exact
            path="/myaccount/transfer/visa-plus/sendtoapp"
            render={props => <SendToApp {...props} />}
          />
        </Switch>
      </Page>
    </Route>
  ) : null
}
